import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { MessageListDonePayload, MessageState, NewMessageSuccessPayload } from "./messageActions";

const initialState: MessageState = {
  messageList: {
    data: [],
    error: null,
    loading: false,
    pagination: null,
  },
  newMessage: 0,
};

export const messageSlide = createSlice({
  initialState,
  name: "message",
  reducers: {
    fetchMessageListDone: (state, action: PayloadAction<MessageListDonePayload>) => {
      const { payload } = action;
      if (payload.error) {
        state.messageList.error = payload.error;
      } else if (payload.data) {
        state.messageList.data = payload.data;
        state.messageList.pagination = payload.pagination;
        state.messageList.error = null;
      }
      state.messageList.loading = false;
    },
    setNewMessage: (state, action: PayloadAction<NewMessageSuccessPayload>) => {
      state.newMessage = action.payload.count;
    },
    startFetchingMessageList: (state) => {
      state.messageList.loading = true;
      state.messageList.error = null;
    },
  },
});

export const { setNewMessage, startFetchingMessageList, fetchMessageListDone } =
  messageSlide.actions;
export default messageSlide.reducer;
